import { EmptyState } from "@components/EmptyState";
import { DocumentItem } from "@components/pages/common/DocumentItem";
import { ListCard, NormalText } from "@components/styles/dataDisplay";
import { EmptyStateDocuments } from "@components/svgs";
import { FetchCustomerData } from "@customTypes/responses/customer";
import DocumentsTabSkeleton from "@pages/skeletons/CustomerDocumentsTabSkeleton";
import { fetchCustomerDocuments } from "@services/documents";
import React from "react";
import { useQuery } from "react-query";

const CustomerDocumentsTab = () => {
  const { data, isSuccess, isLoading } = useQuery({
    queryKey: ["fetchCustomerDocuments"],
    queryFn: () => fetchCustomerDocuments(),
    keepPreviousData: true,
  });

  const { data: customerData } = useQuery<FetchCustomerData>(["customerInfo"]);

  const customerType = customerData?.contactKind === "PERSON" ? "você" : "empresa";

  if (!isSuccess && isLoading) return <DocumentsTabSkeleton />;

  return (
    <div>
      {data.documents?.length < 1 ? (
        <EmptyState
          icon={<EmptyStateDocuments />}
          title={`Nenhum documento relacionado à ${customerType}`}
        >
          <NormalText noMargin>
            Quando o advogado adicionar documentos ou links, eles aparecerão aqui.
          </NormalText>
        </EmptyState>
      ) : (
        <>
          <NormalText margin="xs" color="gray">
            {`Mostrando ${data.documents.length} de ${data.documents.length} documentos`}
          </NormalText>
          <ListCard border>
            {data.documents?.map((document) => (
              <DocumentItem
                key={`${document.documentName}/${document.updateDate}`}
                document={document}
                showRootLawsuit
              />
            ))}
          </ListCard>
        </>
      )}
    </div>
  );
};

export default CustomerDocumentsTab;
